import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { formatNameWithCode } from '~/utils';
import { contactLabel } from '~/utils/contact';
import type { SellerRecipients } from '~/components/common/useSellerRecipients';
import type { RecipientGroup } from '~/pages/buy-lists/sections/RequestForQuoteSummaryPanels';

export function useRequestForQuoteRecipientGroups(
  selectedOrganizations: SellerRecipients['selectedOrganizations']
): RecipientGroup[] {
  const { t } = useTranslation('inventory');
  return useMemo(
    () =>
      selectedOrganizations.map(
        ({ organization, contacts, primaryContactId }) => ({
          organizationId: organization.id,
          organizationLabel: formatNameWithCode(
            organization.name,
            organization.sellingOrganizationCode
          ),
          contacts: contacts.map((contact) => ({
            id: contact.id,
            name:
              contact.id === primaryContactId
                ? t(
                    'inventory.buy_list.request_for_quote.primary_contact_name',
                    { name: contactLabel(contact) }
                  )
                : contactLabel(contact),
          })),
        })
      ),
    [selectedOrganizations, t]
  );
}
